import { Add as AddIcon } from '@mui/icons-material';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { BtnLink, BtnLinkProps } from '../../../../libs/ui/src/components/btn-link/Btn';
import { entityMessages } from './EntityActions.messages';

type Props = Omit<BtnLinkProps, 'to'> & {
  entity?: string;
  children?: React.ReactNode;
};

export function CreateEntityBtn(props: Props) {
  const { entity, children, ...rest } = props;
  const { formatMessage } = useIntl();

  return (
    <BtnLink data-cy="create-entity" to={`/admin/${entity}s/add`} icon={<AddIcon />} {...rest}>
      {children || (
        <FormattedMessage
          id="common.actions.createEntity"
          defaultMessage="Crear"
          values={{
            entity:
              entity && (entityMessages[entity] ? formatMessage(entityMessages[entity]) : entity),
          }}
        />
      )}
    </BtnLink>
  );
}
